import styled, { css } from 'styled-components';
import { SCard10 } from '@shared/styles/styledComponentsCommon';
import { TextInputM } from '@shared/ui/index';
import { NumberTextInputM } from '@shared/ui/inputs/TextInputM/NumberTextInputM/ui';

export const SInputsWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

export const SDeleteButtonAfter = styled.div`
  margin-left: auto;
  @media (width <= 773px) {
    display: none;
  }
`;

export const SDeleteButtonBefore = styled.div`
  button {
    position: relative;
    right: 0;
    margin-left: 10px;
    @media (width > 773px) {
      display: none;
    }
  }
`;

export const SCard = styled(SCard10)`
  padding-top: 15px;
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex-grow: 1;
`;

const maxWidth = css`
  @media (width <= 773) {
    width: 100%;
  }
`;
export const SGroupName = styled(TextInputM)`
  ${maxWidth}
`;
export const SGroupCost = styled(NumberTextInputM)`
  ${maxWidth}
`;

export const SCostNumber = styled.div`
  @media screen and (width < 768px) {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
`;
